import * as React from 'react';
import { useRecoilValue } from 'recoil';
import { useIntl } from 'react-intl';
import { CmdTooltip } from '@commander-services/gui-components';
import { IRide } from '../types';
import {
  activeRideIndexAtom,
  actualPlayPositionAtom,
  selectedRidesAtom,
  showDataLayerAtom,
  speedlimitSettingsAtom,
} from '../RidePlayerState';

interface ISpeedWidgetProps {
  rides: IRide[];
}

export default function SpeedWidget(props: ISpeedWidgetProps): JSX.Element {
  const { formatMessage: f } = useIntl();
  const actualPosition = useRecoilValue(actualPlayPositionAtom);
  const speedlimits = useRecoilValue(speedlimitSettingsAtom);
  const showContent = useRecoilValue(showDataLayerAtom);
  const activeRideIndex = useRecoilValue<number>(activeRideIndexAtom);
  const selectedRides = useRecoilValue<number[]>(selectedRidesAtom);
  const activeRideNumber = selectedRides[activeRideIndex];
  const rideIndex = activeRideNumber - 1;

  const getWidgetColorBySpeedlimitSettings = () => {
    let widgetColor = '#C8C8C8';

    if (
      props.rides[rideIndex] &&
      props.rides[rideIndex].positions &&
      props.rides[rideIndex].positions[actualPosition] &&
      props.rides[rideIndex].positions[actualPosition].speed
    ) {
      const speed = props.rides[rideIndex].positions[actualPosition].speed;
      widgetColor = '#05B590';
      if (speed >= speedlimits.minimumSpeed) {
        widgetColor = '#F7CC00';
      }
      if (speed >= speedlimits.warningSpeed) {
        widgetColor = '#F26827';
      }
      if (speed >= speedlimits.maximumSpeed) {
        widgetColor = '#B50536';
      }
      return widgetColor;
    }
    return widgetColor;
  };

  const getTextColorBySpeedlimitSettings = () => {
    let widgetColor = '#5C5C5C';

    if (
      props.rides[rideIndex] &&
      props.rides[rideIndex].positions &&
      props.rides[rideIndex].positions[actualPosition] &&
      props.rides[rideIndex].positions[actualPosition].speed
    ) {
      const speed = props.rides[rideIndex].positions[actualPosition].speed;
      widgetColor = '#5C5C5C';
      if (speed >= speedlimits.minimumSpeed) {
        widgetColor = '#875E16';
      }
      if (speed >= speedlimits.warningSpeed) {
        widgetColor = '#B65517';
      }
      if (speed >= speedlimits.maximumSpeed) {
        widgetColor = '#B80A39';
      }
      return widgetColor;
    }
    return widgetColor;
  };

  return (
    <div className="item">
      <div className="b-widget b-widget--1x1" style={{ position: 'initial', textAlign: 'center' }}>
        <CmdTooltip
          content={<>{f({ id: 'ridePlayer.widget.speed.tooltip' })}</>}
          width={180}
          customCss={{ whiteSpace: 'nowrap', top: '53px' }}
        >
          <i
            className={`e-widget-icon cmd-icon cmd-icon-speed ${
              props.rides[rideIndex] &&
              props.rides[rideIndex].positions &&
              props.rides[rideIndex].positions[actualPosition] &&
              props.rides[rideIndex].positions[actualPosition].speed &&
              props.rides[rideIndex].positions[actualPosition].speed > speedlimits.maximumSpeed
                ? 'text-primary'
                : ''
            } `}
            style={{ color: getWidgetColorBySpeedlimitSettings() }}
          />
          <div className="e-widget-value">
            <strong
              className={
                props.rides[rideIndex] &&
                props.rides[rideIndex].positions &&
                props.rides[rideIndex].positions[actualPosition] &&
                props.rides[rideIndex].positions[actualPosition].speed &&
                props.rides[rideIndex].positions[actualPosition].speed > speedlimits.maximumSpeed
                  ? 'text-primary'
                  : ''
              }
              style={{ color: getTextColorBySpeedlimitSettings() }}
            >
              {showContent &&
              props.rides[rideIndex] &&
              props.rides[rideIndex].positions &&
              props.rides[rideIndex].positions[actualPosition] &&
              props.rides[rideIndex].positions[actualPosition].speed !== null
                ? props.rides[rideIndex].positions[actualPosition].speed.toFixed(0)
                : '-'}
            </strong>
            {showContent && <small> km/h</small>}
          </div>
        </CmdTooltip>
      </div>
    </div>
  );
}
